export default __webpack_public_path__ + "static/media/solar-light.3adcd430.svg";